import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { PackagesPreview } from "@/components/home/PackagesPreview";
import { HowItWorks } from "@/components/home/HowItWorks";
import { Testimonials, reviewSchema } from "@/components/home/Testimonials";
import { ConsultationForm } from "@/components/home/ConsultationForm";
import { FinalCTA } from "@/components/home/FinalCTA";
import { SEO } from "@/components/SEO";
import { organizationSchema, siteNavigationSchema } from "@/lib/structuredData";

const Index = () => {
  return (
    <Layout>
      <SEO 
        title="Bookkeeping Services South Africa | Professional Bookkeeping & Tax Support"
        description="Professional bookkeeping, payroll, SARS compliance, and tax services for South African businesses. SAICA registered. Packages from R350/month. Book a call today."
        canonical="/"
        structuredData={[organizationSchema, siteNavigationSchema, reviewSchema]}
      />
      <HeroSection />
      <PackagesPreview />
      <HowItWorks />
      <Testimonials />
      <ConsultationForm />
      <FinalCTA />
    </Layout>
  );
};

export default Index;
